'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Private
// ----------------------------------------

let url = window.B2FAPI.paths.thank;

// ----------------------------------------
// Public
// ----------------------------------------

function formMessage (msg) {
	$.magnificPopup.open({
		items: {
			src: url
		},
		type: 'ajax',
		removalDelay: 300,
		mainClass: 'zoom-in',
		closeMarkup: '<button class="mfp-close" id="custom-close-ajax"></button>',
		callbacks: {
			ajaxContentAdded: function () {
				$('.thank-popup__text').text(msg);
			}
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {formMessage};



// WEBPACK FOOTER //
// ./src/js/_modules/form-message.js